// extracted by mini-css-extract-plugin
export default {"HomepageBackground":"HomePage_HomepageBackground__WfCak","transition":"HomePage_transition__Pc1rN","return":"HomePage_return__eM5aj"};